// B1 intent-first funnel (2026-02): CTAs remember WHY the visitor came
// (help / need_help / community). The value survives login + signup in
// sessionStorage and routes their first post-onboarding screen.
// Shared by the landing hero and the three-pillar section (Phase 16 item 3
// moved the community/neighbour CTAs out of the hero).
export const rememberIntent = (v) => {
  try { sessionStorage.setItem("civic_intent", v); } catch { /* private mode */ }
};
